if (!customElements.get('slept-search-rotator')) {
  customElements.define(
    'slept-search-rotator',
    class SleptSearchRotator extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-search-rotation-item]'));
        this.index = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
        this.interval = Math.max(1000, Number(this.dataset.interval) || 3000);
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!this.items.length) return;
        this.items.forEach((item, index) => {
          item.classList.toggle('is-active', index === this.index);
        });

        if (this.items.length > 1 && !this.motionQuery.matches) {
          this.start();
          document.addEventListener('visibilitychange', this.onVisibilityChange, { signal: this.abortController.signal });
        }
      }

      disconnectedCallback() {
        this.stop();
        this.abortController?.abort();
      }

      get abortController() {
        if (!this._abortController || this._abortController.signal.aborted) {
          this._abortController = new AbortController();
        }
        return this._abortController;
      }

      onVisibilityChange = () => {
        if (document.hidden) this.stop();
        else this.start();
      };

      start() {
        this.stop();
        if (this.items.length < 2 || document.hidden) return;
        this.timer = window.setInterval(() => this.next(), this.interval);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      next() {
        const previous = this.items[this.index];
        this.index = (this.index + 1) % this.items.length;
        const next = this.items[this.index];
        previous?.classList.remove('is-active');
        next?.classList.add('is-active');
      }
    }
  );
}
